<template>
    <v-select
        dense
        outlined
        hide-details
        background-color="white"
        clearable
        :items="items"
        :placeholder="$t('banner_location')"
        v-bind="$attrs"
        v-on="$listeners"
    >
    </v-select>
</template>

<script>
import { LOCATION as BannerLocation } from '@/models/Banner';

export default {
    name: 'BannerLocationSelect',
    created() {
        this.items = Object.entries(BannerLocation).map((item) => {
            return {
                value: item[0],
                text: this.$t(item[1].title_key),
            };
        });
    },
};
</script>
